import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('dental_benefits_set_review', '/dental_benefits_set_reviews', 'review')
const reducer = generator.generate()

export default reducer
